import React, { useEffect, useState } from 'react';

const QuadratureAnimation = ({ isActive }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setStep(0);
      return;
    }
    const id = setInterval(() => {
      setStep((s) => (s + 1) % 4);
    }, 1500);
    return () => clearInterval(id);
  }, [isActive]);

  return (
    <div className="rounded-lg overflow-hidden">
      <svg
        viewBox="0 0 100 90"
        width="100%"
        height="100%"
        style={{ backgroundColor: '#0d9488' }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern id="hatch" patternUnits="userSpaceOnUse" width="4" height="4">
            <path d="M0 4 L4 0" stroke="#f3f4f6" strokeWidth="1" />
          </pattern>
        </defs>

        <line x1="8" y1="80" x2="90" y2="80" stroke="#f3f4f6" strokeWidth="4" />
        <line x1="10" y1="20" x2="10" y2="80" stroke="#f3f4f6" strokeWidth="4" />

        <path d="M10 60 Q 30 20 50 40 T 90 30" stroke="#f3f4f6" strokeWidth="3" fill="none" />

        {step >= 1 && (
          <rect x="15" y="40" width="20" height="40" fill="url(#hatch)" stroke="#f3f4f6" strokeWidth="1" />
        )}
        {step >= 2 && (
          <rect x="35" y="35" width="20" height="45" fill="url(#hatch)" stroke="#f3f4f6" strokeWidth="1" />
        )}
        {step >= 3 && (
          <rect x="55" y="47" width="20" height="33" fill="url(#hatch)" stroke="#f3f4f6" strokeWidth="1" />
        )}
      </svg>
    </div>
  );
};

export default QuadratureAnimation;

